import { useState, useEffect, useRef } from 'react';
import { useOutletContext, useLocation } from 'react-router-dom';
import Uploader from '../../components/uploader/Uploader';
import { defaultLanguageWithLabels } from 'utils/languages';
import CancelIcon from '@mui/icons-material/Cancel';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import {
  Box,
  Grid,
  Stack,
  Button,
  TextField,
  InputLabel,
  LinearProgress,
  Typography,
} from '@mui/material';
import KeyboardAltOutlinedIcon from '@mui/icons-material/KeyboardAltOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Divider } from '@aws-amplify/ui-react';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import NotInterestedOutlinedIcon from '@mui/icons-material/NotInterestedOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import SignLanguageOutlinedIcon from '@mui/icons-material/SignLanguageOutlined';
import Modal from '../../components/common/Modal';
import { AsyncPaginate } from 'react-select-async-paginate';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { useGlobalStore } from 'store/globalStore';
import { Tooltip } from 'components/Tooltip';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import { CRUD_STATES } from 'constants/app';
import { deleteAudio } from '../series/Resources';
import ClosedCaptionIcon from '@mui/icons-material/ClosedCaption';
import Chip from '@mui/material/Chip';
import SurroundSoundIcon from '@mui/icons-material/SurroundSound';
import { useNotification } from 'hooks/useNotification';
import { useUploadData } from 'hooks/useUploadData';
import { mediaAPI, videoAPI } from 'services/admin';

function StepTwo(props) {
  const {
    register,
    control,
    getValues,
    setValue,
    setVideoProps,
    languages,
    viewFields,
    viewStepTwoFields,
  } = props;
  const { isLoading, setIsLoading } = useAppProviderStore();
  const { getFormatedFileUploadById } = useUploadData();

  const trailerUploadProgress = getFormatedFileUploadById('trailer_file');

  const legendaTrailerUploadProgress = getFormatedFileUploadById(
    'subtitle_trailer_language_file'
  );
  const audioTrailerUploadProgress =
    getFormatedFileUploadById('audio_file_trailer');

  const videoAcessibilityUploadProgress =
    getFormatedFileUploadById('trailer_sign_file');
  const legendaAccessibilityUploadProgress = getFormatedFileUploadById(
    'subtitle_trailer_sign_language_file'
  );

  const { setNotify } = useNotification();
  const fileInputAudioRef = useRef(null);
  const location = useLocation();
  const [canAddAudio, setCanAddAudio] = useState(false);
  const [audioIdioma, setAudioIdioma] = useState([]);
  const [audioFiles, setAudioFiles] = useState([]);
  const [trailerLegend, setTrailerLegend] = useState(null);
  const [trailerLegendSignal, setTrailerLegendSignal] = useState(null);
  // (Trailer) arquivo de vídeo do trailer
  const [trailerVideoFiles, setTrailerVideoFiles] = useState(null);
  // idioma principal do trailer
  const [trailerDefaultLanguage, setTrailerDefaultLanguage] = useState([]);
  const fileInputVideoTrailerRef = useRef(null);
  const { setCancelUpload } = useGlobalStore();

  // (Legendas trailer) arquivo de legenda do trailer
  const [subtitleTrailerFiles, setSubtitleTrailerFiles] = useState([]);
  // idioma opcional do trailer
  const [trailerLanguageOption, setTrailerLanguageOption] = useState([]);
  const fileInputSubtitleVideoTrailerRef = useRef(null);
  // (Vídeo de linguagem de sinais) arquivo do vídeo de linguagem de sinais
  const [videoSignLanguageFile, setVideoSignLanguageFile] = useState(null);
  // (Idioma do áudio do trailer) idioma do vídeo de linguagem de sinais
  const [videoSignLanguage, setVideoSignLanguage] = useState([]);
  const fileInputVideoSignRef = useRef(null);
  const [auth, setAuth] = useOutletContext();
  const [
    subtitleVideoSignLanguageOptionFile,
    setSubtitleVideoSignLanguageOptionFile,
  ] = useState([]);
  const { showConfirmationButton } = useState(true);

  const [subtitleVideoSignLanguageOption, setSubtitleVideoSignLanguageOption] =
    useState([]);
  const fileInputSubtitleVideoSignLanguageOptionRef = useRef(null);

  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });

  const session = auth;
  const idToken = session.getIdToken().getJwtToken();
  const userId = session.getIdToken().payload.sub;
  const userName = session.getIdToken().payload.username;

  // setValue("trailerId", '3c8c5edd-487f-452c-8f08-5efe0763a34d');

  const handleResetLanguage = () => {
    setTimeout(() => {
      setValue('subtitle_trailer_language', null);
      setValue('subtitle_sign_language', null);
      setValue('audio_idioma', null);
    }, 500);
  };

  useEffect(() => {
    if (isLoading === false) {
      handleResetLanguage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  const handleDeleteTrailerLanguageOption = (file, idioma, index) => {
    return new Promise((resolve, reject) => {
      setIsLoading(true);
      let trailerId = '';
      let subtitleId = '';
      let sub = getValues('subtitle_trailerId');
      if (sub) {
        let findSub = sub.find(obj => {
          return obj.name === file.name;
        });
        trailerId = findSub?.mediaId;
        subtitleId = findSub?.subtitleId;
      } else {
        trailerId = getValues('trailerId');
        subtitleId = file?.subtitleId;
      }
      const path = `/${trailerId}/subtitles/${subtitleId}`;

      setConfirmDialogAction({
        isOpen: false,
      });

      if (uploadVerification(legendaTrailerUploadProgress)) {
        setCancelUpload(true);
        deleteFilesFromList(
          subtitleTrailerFiles,
          setSubtitleTrailerFiles,
          index
        );
        console.log('Mídia removida pelo  usuário Durante o upload');
        setNotify({
          isOpen: true,
          message: 'Processo de upload interrompido pelo usuário!',
          type: 'success',
          title: 'Sucesso!',
        });
      } else {
        setNotify({
          isOpen: true,
          message: `Legenda removida com sucesso.`,
          type: 'success',
          title: 'Sucesso!',
        });

        return mediaAPI
          .del(path)
          .then(resp => {
            setIsLoading(false);
            deleteFilesFromList(
              subtitleTrailerFiles,
              setSubtitleTrailerFiles,
              index
            );
            deleteFilesFromList(
              trailerLanguageOption,
              setTrailerLanguageOption,
              index
            );

            resolve(resp);
          })
          .catch(error => {
            setIsLoading(false);

            setNotify({
              isOpen: true,
              message: error.details || error.message,
              type: 'error',
              title: 'Passo 2: Erro ao remover legenda do trailer.',
            });
            console.log(error);
          });
      }
    });
  };

  async function handleDeleteSignLanguageOption(file, idioma, index) {
    return new Promise((resolve, reject) => {
      setIsLoading(true);
      let mediaWithAcessibilityId = getValues('mediaWithAcessibilityId');
      const path = `/${mediaWithAcessibilityId}/subtitles/${file?.subtitleId}`;

      setConfirmDialogAction({
        isOpen: false,
      });

      return mediaAPI
        .del(path)
        .then(resp => {
          setIsLoading(false);

          deleteFilesFromList(
            subtitleVideoSignLanguageOptionFile,
            setSubtitleVideoSignLanguageOptionFile,
            index
          );
          deleteFilesFromList(
            subtitleVideoSignLanguageOption,
            setSubtitleVideoSignLanguageOption,
            index
          );
          setValue(
            'subtitle_sign_language',
            deleteFilesFromList(subtitleVideoSignLanguageOption, false, index)
          );

          setNotify({
            isOpen: true,
            message: `Legenda removida com sucesso.`,
            type: 'success',
            title: 'Sucesso!',
          });
          resolve(resp);
        })
        .catch(error => {
          setIsLoading(false);
          setNotify({
            isOpen: true,
            message: error.details ? error.details : error.message,
            type: 'error',
            title: 'Passo 2: Erro ao Excluir legenda de linguagem de sinais.',
          });
          console.log(error);
        });
    });
  }

  const handleDeletevideoSignLanguage = (file, mediaId, id, version) => {
    return new Promise((resolve, reject) => {
      setIsLoading(true);
      const path = `/${id}/versions/${version}/media/${mediaId}`;
      const session = auth;

      const data = {
        createdBy: {
          userId: session.getIdToken().payload.sub,
          name: session.getIdToken().payload.username,
        },
      };

      setConfirmDialogAction({
        isOpen: false,
      });

      return videoAPI
        .del(path, data)
        .then(resp => {
          setIsLoading(false);
          setVideoSignLanguageFile(null);
          setVideoSignLanguage([]);
          setSubtitleVideoSignLanguageOptionFile([]);
          setValue('mediaWithAcessibilityId', '');
          setValue('video_sign_trailer_language', '');

          setNotify({
            isOpen: true,
            message: resp.details || resp.message,
            type: 'success',
            title: 'Sucesso!',
          });
          resolve(resp);
        })
        .catch(error => {
          setIsLoading(false);
          setNotify({
            isOpen: true,
            message: error.details || error.message,
            type: 'error',
            title: 'Passo 2: Erro ao excluir vídeo de linguagem de sinais.',
          });
          console.log(error);
        });
    });
  };

  const getAudioTrailerById = async mediaId => {
    let response = await getMediaById(auth, mediaId);

    let audioTracks = response?.audioTracks;
    if (audioTracks?.length > 0) {
      let tempTracks = [];
      for (let audio of audioTracks) {
        tempTracks.push({
          name: audio?.language?.fileName || audio?.id,
          label: audio?.language?.name,
          audioTrackId: audio?.id,
          accessibility: audio?.accessibility,
        });
      }
      setAudioFiles(tempTracks);
      setAudioIdioma(tempTracks);
    }
  };

  const getMediaById = async (auth, mediaId) => {
    return new Promise((resolve, reject) => {
      const path = `/${mediaId}`;
      const session = auth;

      const data = {
        createdBy: {
          userId: session.getIdToken().payload.sub,
          name: session.getIdToken().payload.username,
        },
      };

      return mediaAPI
        .get(path, data)
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
          console.log(error);
        });
    });
  };

  const getMediaAccessibilityById = async mediaId => {
    let response = await getMediaById(auth, mediaId);

    setVideoProps(prevState => ({
      ...prevState,
      ACCESSIBILITY: {
        mediaWithAcessibilityId: mediaId,
        mediaId: mediaId,
        mediaType: response?.extension,
        name: response?.fileName,
      },
    }));

    setVideoSignLanguageFile(prevState => ({
      ...prevState,
      ACCESSIBILITY: {
        mediaWithAcessibilityId: mediaId,
        mediaId: mediaId,
        mediaType: response?.extension,
        name: response?.fileName,
      },
    }));

    const filtered = languages.filter(language =>
      language.uuid.includes(response?.audioLanguage)
    );

    setVideoSignLanguage({
      name: filtered[0]?.uuid,
      label: filtered[0]?.name,
    });
    setValue('video_sign_trailer_language', {
      name: response?.audioLanguage,
      label: response?.audioLanguage,
    });

    let subtitles = response?.subtitles;
    if (subtitles?.length > 0) {
      let tempSubs = [];
      for (let sub of subtitles) {
        tempSubs.push({
          name: sub?.language?.fileName,
          label: sub?.language?.name,
          subtitleId: sub?.id,
          accessibility: sub?.accessibility,
        });
      }

      setSubtitleVideoSignLanguageOptionFile(tempSubs);
      setSubtitleVideoSignLanguageOption(tempSubs);
    }
  };

  const getMediaTrailerById = async mediaId => {
    let response = await getMediaById(auth, mediaId);

    setVideoProps(prevState => ({
      ...prevState,
      trailer: {
        trailerId: mediaId,
        mediaId: mediaId,
        mediaType: response?.extension,
        name: response?.fileName,
      },
    }));
    let filtered = languages.filter(language =>
      language.uuid.includes(response?.audioLanguage)
    );

    setTrailerDefaultLanguage({
      name: filtered[0]?.uuid,
      label: filtered[0]?.name,
    });

    setTrailerVideoFiles(prevState => ({
      ...prevState,
      trailer: {
        trailerId: mediaId,
        mediaId: mediaId,
        mediaType: response?.extension,
        name: response?.fileName,
      },
    }));
    let subtitles = response?.subtitles;

    if (subtitles?.length > 0) {
      let tempSubs = [];

      for (let sub of subtitles) {
        tempSubs.push({
          name: sub?.language?.fileName,
          label: sub?.language?.name,
          subtitleId: sub?.id,
          accessibility: sub?.accessibility,
        });
      }
      setSubtitleTrailerFiles(tempSubs);
      setTrailerLanguageOption(tempSubs);
      setValue('trailer_audio_language', {
        label: response?.audioLanguage,
        name: response?.audioLanguage,
      });
      setValue('subtitle_trailer_language', tempSubs);
    }
  };

  useEffect(() => {
    if (
      [CRUD_STATES.EDIT, CRUD_STATES.CREATE, CRUD_STATES.VIEW].includes(
        location?.state?.action
      )
    ) {
      (async () => {
        setIsLoading(true);
        const mediaId = getValues('mediaWithAcessibilityId');
        if (mediaId) {
          await getMediaAccessibilityById(mediaId);
        }
        const trailerId = getValues('trailerId');
        if (trailerId) {
          await getMediaTrailerById(trailerId);
        }
        if (trailerId) {
          await getAudioTrailerById(trailerId);
        }
        setIsLoading(false);
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const uploadVerification = file => {
    return !!(file?.percent > 0 && file?.percent < 100);
  };

  const submitMediaDeleteCancel = (mediaId, id, version) => {
    return new Promise((resolve, reject) => {
      setIsLoading(true);
      const path = `/${id}/versions/${version}/media/${mediaId}`;
      const session = auth;

      const data = {
        createdBy: {
          userId: session.getIdToken().payload.sub,
          name: session.getIdToken().payload.username,
        },
      };

      return videoAPI
        .del(path, data)
        .then(resp => {
          setIsLoading(false);
          setTrailerVideoFiles([]);
          setTrailerDefaultLanguage([]);
          setSubtitleTrailerFiles([]);
          setCanAddAudio(false);
          setAudioFiles([]);
          setAudioIdioma([]);
          setValue('trailerId', '');
          setValue('trailer_audio_language', '');
          setValue('video_media', '');

          audioFiles.map((data, index) => {
            deleteFilesFromList(audioIdioma, setAudioIdioma, index);
            setValue(
              'audio_idioma',
              deleteFilesFromList(audioIdioma, false, index)
            );
          });
          subtitleTrailerFiles.map((data, index) => {
            deleteFilesFromList(
              subtitleTrailerFiles,
              setSubtitleTrailerFiles,
              index
            );

            setValue(
              'subtitle_trailer_language',
              deleteFilesFromList(subtitleTrailerFiles, false, index)
            );
          });

          setNotify({
            isOpen: true,
            message: resp.details || resp.message,
            type: 'success',
            title: 'Sucesso!',
          });
          resolve(resp);
        })
        .catch(error => {
          setIsLoading(false);
          console.log(error);
        });
    });
  };
  async function handleDeleteMedia(
    idioma,
    videoUploadProgress,
    trailerId,
    id,
    version
  ) {
    // let response = await getMediaById(auth, getValues("mediaId"));
    // let audiotracks = response?.message?.audioTracks;
    // if (audiotracks) {
    //   for (let tracksId of audiotracks) {
    //     fields.push(tracksId.id);
    //   }
    // }
    // let subtitles = response?.message?.subtitles;
    // if (subtitles) {
    //   for (let subtitle of subtitles) {
    //     fields.push(subtitle.id);
    //   }
    // }

    setConfirmDialogAction({ isOpen: false });
    if (uploadVerification(videoUploadProgress)) {
      setCancelUpload(true);
      console.log('Mídia removida pelo  usuário Durante o upload');
      setNotify({
        isOpen: true,
        message: 'Processo de upload interrompido pelo usuário!',
        type: 'success',
        title: 'Sucesso!',
      });
      submitMediaDeleteCancel(trailerId, id, version);
    } else {
      submitMediaDeleteCancel(trailerId, id, version);
    }
  }

  const deleteFilesFromList = (files, setFiles, indexToRemove) => {
    const updatedItems = files.filter((item, index) => index !== indexToRemove);
    setFiles && setFiles(updatedItems);
    return updatedItems;
  };

  return (
    <div
      className="step-container"
      style={{ position: 'relative' }}
      id="step-two">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="video_label-title">Trailer</div>
          <PlayCircleOutlinedIcon style={{ color: 'rgba(81, 93, 113, 1)' }} />
          <span className="video-subtitle">Trailer</span>
          <Divider className="mr-divider" />
        </Grid>
        {trailerVideoFiles?.trailer?.trailerId && (
          <>
            <Grid item xs={4}>
              <Form.Group
                style={{ height: 'auto' }}
                controlId="formUnit"
                id="trailer-language-video-select">
                <InputLabel
                  className="form-label"
                  id="select-standard-label-trailer"
                  htmlFor="units">
                  Idioma do trailer
                </InputLabel>
                <TextField
                  value={
                    trailerDefaultLanguage?.label ||
                    trailerDefaultLanguage[0]?.label
                  }
                  fullWidth
                  variant="standard"
                  disabled={true}
                  style={{ marginTop: 6 }}
                  id="trailer-selected-language-value"
                />
              </Form.Group>
            </Grid>
            <Grid item xs={8}>
              <Form.Group
                style={{ height: 'auto', paddingRight: 15 }}
                controlId="formVideoFile">
                <div className="file-container">
                  <div style={{ maxWidth: 300, marginRight: 15 }}>
                    <InputLabel
                      className="select-label"
                      style={{ marginBottom: 25, marginTop: 0 }}>
                      Arquivo
                    </InputLabel>

                    <Controller
                      name={'video_media'}
                      control={control}
                      render={({
                        field: { onChange, value, onBlur },
                        fieldState: { error, invalid, isTouched, isDirty },
                        formState,
                      }) => (
                        <span
                          // onClick={ClickHandler}
                          // href="/"

                          style={{
                            fontWeight: '400',
                            color: '#0000CC',
                            borderBottom: '1px solid rgba(208, 213, 221, 1)',
                            textDecoration: 'none',
                            overflowWrap: 'break-word',
                          }}
                          onChange={e => {
                            onChange(e);
                            // setSelectedName(e.target.value)
                          }}
                          value={value}
                          onBlur={onBlur}
                          disabled={!!viewFields || !!viewStepTwoFields}
                          id="trailer-filename">
                          {trailerVideoFiles?.trailer?.name}
                        </span>
                      )}
                    />
                  </div>
                  <Button
                    color="error"
                    id="video-remove-midia-file"
                    style={{
                      textTransform: 'capitalize',
                      color: 'rgba(255, 98, 98, 1)',
                    }}
                    startIcon={
                      uploadVerification(trailerUploadProgress) ? (
                        <CancelIcon />
                      ) : (
                        <NotInterestedOutlinedIcon />
                      )
                    }
                    onClick={async () => {
                      setConfirmDialogAction({
                        isOpen: true,
                        title: (
                          <div className="modalTitleText">
                            Deseja remover a mídia?
                          </div>
                        ),
                        subTitle: (
                          <div className="modalBodyText">
                            Você está deletando o arquivo permanentemente,
                            deseja prosseguir?
                          </div>
                        ),
                        children: (
                          <div className="modalRemoveItem">
                            <DeleteOutlineOutlinedIcon
                              color="error"
                              fontSize="12px"
                            />
                          </div>
                        ),
                        confirmTextButton: 'Sim',
                        color: 'error',
                        onConfirm: async () => {
                          await handleDeleteMedia(
                            trailerDefaultLanguage[0],
                            trailerUploadProgress,
                            getValues('trailerId'),
                            getValues('id'),
                            getValues('version')
                          );
                        },
                        showConfirmationButton: { showConfirmationButton },
                        closeTextButton: 'Não',
                      });
                    }}
                    disabled={!!viewFields}>
                    {uploadVerification(trailerUploadProgress)
                      ? 'Cancelar'
                      : 'Remover'}
                  </Button>
                </div>
              </Form.Group>
            </Grid>
          </>
        )}
        {!trailerVideoFiles?.trailer?.trailerId && (
          <Grid
            item
            xs={4}
            className={
              trailerVideoFiles?.trailer?.trailerId
                ? 'select-label hidden'
                : 'select-label '
            }>
            <Form.Group
              style={{ height: 'auto' }}
              controlId="formUnit"
              id="trailer-video-language">
              <InputLabel>Idioma do áudio do trailer</InputLabel>
              <Controller
                name={'trailer_audio_language'}
                control={control}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { errors, isValid, isTouched, isDirty },
                  formState,
                }) => (
                  <AsyncPaginate
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        '&:hover': {
                          borderColor: 'transparent',
                          borderRadius: '0px',
                          border: 0,
                          borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                        },
                        borderRadius: '0px',
                        border: 0,
                        borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                        width: 'auto',
                        padding: 0,
                        margin: 0,
                        marginTop: '10px',
                      }),
                      singleValue: base => ({
                        ...base,
                        // padding: 5,
                        borderRadius: 6,
                        color: 'rgba(25, 28, 31, 1)',
                        fontSize: '15px',
                        display: 'flex',
                      }),
                      menuList: base => ({
                        ...base,
                        maxHeight: '150px',
                      }),
                    }}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#e9e9ea',
                        primary: '#0A6CCF',
                        width: 'auto',
                      },
                    })}
                    menuPosition="fixed"
                    noOptionsMessage={() => 'Nada encontrado'}
                    id="video-trailer-select-language"
                    loadingMessage={() => 'Carregando...'}
                    loadOptions={defaultLanguageWithLabels}
                    // isMulti
                    value={value || { value: '', label: 'Selecione o Idioma' }}
                    isSearchable={true}
                    onBlur={e => {
                      onBlur(e);
                    }}
                    isDisabled={Boolean(viewFields || viewStepTwoFields)}
                    placeholder="Selecione o idioma"
                    onChange={selectedOption => {
                      onChange(selectedOption);
                      setTrailerDefaultLanguage(prevSubtitle => [
                        ...prevSubtitle,
                        selectedOption,
                      ]);
                    }}
                  />
                )}
              />
            </Form.Group>
          </Grid>
        )}
        <Grid item xs={8}>
          <div className="file-container">
            <div>
              <InputLabel
                className={
                  trailerVideoFiles?.trailer?.trailerId
                    ? 'select-label  hidden'
                    : 'select-label'
                }
                // !getValues('trailer_audio_language') || getValues('trailerId')
                style={{ marginBottom: 12, marginTop: 0 }}>
                Arquivo
              </InputLabel>
              <Tooltip.Info
                title="Atenção"
                description="Antes de selecionar o arquivo selecione o idioma"
                show={
                  !trailerVideoFiles?.trailer?.trailerId &&
                  (!getValues('trailer_audio_language') ||
                    getValues('trailerId') ||
                    viewFields ||
                    viewStepTwoFields)
                }>
                <Uploader
                  register={register}
                  name={'trailer_file'}
                  icon={<FileUploadOutlinedIcon />}
                  accept={
                    'video/AIV,video/MP4,video/MOV,video/WEBM,video/MXF,video/WMV,video/MPEG,video/3GP,video/ASF,video/mp4,video/x-m4v,video/*'
                  }
                  fileInputRef={fileInputVideoTrailerRef}
                  file={trailerVideoFiles}
                  title={'Selecionar Trailer'}
                  isDisabled={
                    !getValues('trailer_audio_language') ||
                    getValues('trailerId') ||
                    viewFields ||
                    viewStepTwoFields
                  }
                  apiName={'admin'}
                  path={`/admin/media`}
                  token={idToken}
                  id={getValues('id')}
                  language={getValues('trailer_audio_language')}
                  userId={userId}
                  userName={userName}
                  setIsLoading={setIsLoading}
                  isLoading={isLoading}
                  setProps={setTrailerVideoFiles}
                  setNotify={setNotify}
                  type={{ label: 'video', name: 'TRAILER' }}
                  getValues={getValues}
                  setValue={setValue}
                  setAuth={setAuth}
                />
              </Tooltip.Info>
              {trailerUploadProgress?.percent > 0 &&
                trailerUploadProgress?.percent < 100 && (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ width: '100%', mr: 1 }}>
                      <label style={{ fontSize: '12px', color: 'blue' }}>
                        {trailerUploadProgress?.name}
                      </label>
                      <LinearProgress
                        variant="determinate"
                        value={trailerUploadProgress?.percent}
                        sx={{ width: '100%' }}
                      />
                    </Box>
                    <Box sx={{ minWidth: 35 }}>
                      <Typography variant="body2" color="text.secondary">
                        {trailerUploadProgress?.percent}%
                      </Typography>
                    </Box>
                  </Box>
                )}
            </div>
          </div>
        </Grid>

        <Grid item xs={12} style={{ marginTop: 27 }}>
          <KeyboardAltOutlinedIcon style={{ color: 'rgba(81, 93, 113, 1)' }} />
          <span className="video-subtitle">Legenda(s) do trailer</span>
          <Divider className="mr-divider" />
        </Grid>
        {subtitleTrailerFiles.map(
          (file, index) =>
            subtitleTrailerFiles[index] && (
              <Grid container spacing={2} key={index} sx={{ padding: '15px' }}>
                <Grid item xs={4}>
                  <Form.Group style={{ height: 'auto' }} controlId="formUnit">
                    <InputLabel
                      className="form-label"
                      id="select-standard-label"
                      htmlFor="units">
                      Idioma
                    </InputLabel>
                    <TextField
                      value={subtitleTrailerFiles[index]?.label}
                      fullWidth
                      variant="standard"
                      disabled={true}
                      style={{ marginTop: 6 }}
                      id="trailer-subtitle-select-value"
                    />
                  </Form.Group>
                </Grid>

                <Grid item xs={8}>
                  <div className="file-container">
                    <div style={{ maxWidth: '300px' }}>
                      <InputLabel
                        className="select-label"
                        style={{ marginBottom: 24, marginTop: 0 }}>
                        Arquivo
                        <span
                          name={'legenda_' + index + '_idioma'}
                          href="/"
                          //onClick={ClickHandler}
                          disabled={viewFields}
                          id="video-subtitle-accessibility">
                          {file.accessibility === 'true' ||
                          file.accessibility === true ? (
                            <Chip
                              icon={<ClosedCaptionIcon color="primary" />}
                              label="Legenda - Closed Caption"
                              sx={{ fontSize: '12px', marginLeft: '5px' }}
                              size="small"
                            />
                          ) : (
                            ''
                          )}
                        </span>
                      </InputLabel>

                      <span
                        // onClick={ClickHandler}
                        name={'legenda_' + index + '_idioma'}
                        // href="#"
                        style={{
                          fontWeight: '400',
                          color: '#0000CC',
                          borderBottom: '1px solid rgba(208, 213, 221, 1)',
                          textDecoration: 'none',
                          overflowWrap: 'break-word',
                        }}
                        disabled={Boolean(viewFields || viewStepTwoFields)}
                        id="trailer-subtitle-filename">
                        {file.name
                          ? file.name
                          : getValues('subtitle_trailer_language')}
                      </span>
                    </div>

                    {/* {(legendaTrailerUploadProgress?.percent === 100 ||
                      legendaTrailerUploadProgress === false) && ( */}
                    <Button
                      disabled={
                        legendaTrailerUploadProgress?.percent === 100 ||
                        legendaTrailerUploadProgress === false
                          ? false
                          : true
                      }
                      // disabled={viewFields || viewStepTwoFields}
                      color="error"
                      id="trailer-remove-subtitle-file"
                      style={{
                        textTransform: 'capitalize',
                        color:
                          legendaTrailerUploadProgress?.percent === 100 ||
                          legendaTrailerUploadProgress === false
                            ? 'rgba(255, 98, 98, 1)'
                            : 'rgba(0, 0, 0, 0.38)',
                      }}
                      startIcon={<NotInterestedOutlinedIcon />}
                      onClick={() => {
                        setConfirmDialogAction({
                          isOpen: true,
                          title: (
                            <div className="modalTitleText">
                              Deseja remover a legenda?
                            </div>
                          ),
                          subTitle: (
                            <div className="modalBodyText">
                              Você está deletando o arquivo permanentemente,
                              deseja prosseguir?
                            </div>
                          ),
                          children: (
                            <div className="modalRemoveItem">
                              <DeleteOutlineOutlinedIcon
                                color="error"
                                fontSize="12px"
                              />
                            </div>
                          ),
                          confirmTextButton: 'Sim',
                          color: 'error',
                          onConfirm: async () => {
                            await handleDeleteTrailerLanguageOption(
                              file,
                              trailerLanguageOption[index],
                              index

                              // trailerDefaultLanguage[0],
                              // trailerUploadProgress,
                              // getValues('trailerId'),
                              // getValues('id'),
                              // getValues('version')
                            );
                          },
                          showConfirmationButton: {
                            showConfirmationButton,
                          },
                          closeTextButton: 'Não',
                        });
                      }}>
                      Remover
                    </Button>
                    {/* )} */}
                  </div>
                </Grid>
              </Grid>
            )
        )}

        <>
          <Grid item xs={4}>
            <Form.Group
              style={{ height: 'auto' }}
              controlId="formUnit"
              id="trailer-subtitle-select">
              <Controller
                name={'subtitle_trailer_language'}
                control={control}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { errors, isValid, isTouched, isDirty },
                  formState,
                }) => (
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: '224px auto',
                      gap: 2,
                    }}>
                    <Box>
                      <InputLabel className="select-label">Idioma</InputLabel>
                      <AsyncPaginate
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            '&:hover': {
                              borderColor: 'transparent',
                              borderRadius: '0px',
                              border: 0,
                              borderBottom:
                                '1px solid var(--gray-300, #D0D5DD)',
                            },
                            borderRadius: '0px',
                            border: 0,
                            borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                            width: 'auto',
                            padding: 0,
                            margin: 0,
                          }),
                          singleValue: base => ({
                            ...base,
                            // padding: 5,
                            borderRadius: 6,
                            color: 'rgba(25, 28, 31, 1)',
                            fontSize: '15px',
                            display: 'flex',
                          }),
                          menuList: base => ({
                            ...base,
                            maxHeight: '150px',
                          }),
                        }}
                        theme={theme => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            primary25: '#e9e9ea',
                            primary: '#0A6CCF',
                            width: 'auto',
                          },
                        })}
                        menuPosition="fixed"
                        noOptionsMessage={() => 'Nada encontrado'}
                        loadingMessage={() => 'Carregando...'}
                        loadOptions={defaultLanguageWithLabels}
                        isDisabled={Boolean(
                          !getValues('trailerId') ||
                            viewFields ||
                            viewStepTwoFields
                        )}
                        value={
                          value || { value: '', label: 'Selecione o Idioma' }
                        }
                        isSearchable={true}
                        placeholder="Selecione o idioma"
                        onChange={selectedOption => {
                          onChange(selectedOption);
                          setTrailerLegend(selectedOption);
                        }}
                      />
                    </Box>
                    <Box>
                      <InputLabel className="select-label">Arquivo</InputLabel>
                      <Tooltip.Info
                        title="Atenção"
                        description="Antes de selecionar o arquivo selecione o idioma"
                        show={
                          !getValues('subtitle_trailer_language') ||
                          viewFields ||
                          viewStepTwoFields ||
                          !value ||
                          !trailerVideoFiles?.trailer?.trailerId
                        }>
                        <Uploader
                          register={register}
                          name={'subtitle_trailer_language_file'}
                          icon={<FileUploadOutlinedIcon />}
                          accept={'.srt,.txt,.vvt'}
                          fileInputRef={fileInputSubtitleVideoTrailerRef}
                          file={subtitleTrailerFiles}
                          title={'Selecionar legenda'}
                          isDisabled={
                            !getValues('subtitle_trailer_language') ||
                            viewFields ||
                            viewStepTwoFields ||
                            !value ||
                            !trailerVideoFiles?.trailer?.trailerId
                          }
                          apiName={'admin'}
                          path={`/admin/media/${getValues(
                            'trailerId'
                          )}/subtitles`}
                          token={idToken}
                          id={getValues('id')}
                          language={trailerLegend}
                          languages={languages}
                          userId={userId}
                          userName={userName}
                          setIsLoading={setIsLoading}
                          isLoading={isLoading}
                          setProps={setSubtitleTrailerFiles}
                          setNotify={setNotify}
                          type={{ label: 'legenda', name: 'TRAILER' }}
                          getValues={getValues}
                          setValue={setValue}
                          setAuth={setAuth}
                          isAcessibilityCheck={true}
                          nameIsAcessibilityCheck={'legend'}
                        />
                      </Tooltip.Info>
                      {legendaTrailerUploadProgress?.percent > 0 &&
                        legendaTrailerUploadProgress?.percent < 100 && (
                          <Stack
                            sx={{
                              width: '100%',
                              color: 'grey.500',
                              padding: '15px',
                            }}
                            spacing={2}>
                            <label>{legendaTrailerUploadProgress?.name}</label>
                            <LinearProgress
                              color="secondary"
                              variant="determinate"
                              value={legendaTrailerUploadProgress?.percent}
                            />
                          </Stack>
                        )}
                    </Box>
                  </Box>
                )}
              />
            </Form.Group>
          </Grid>
        </>
      </Grid>

      {/* aqui acaba o for da legenda trailer */}
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ marginTop: 27 }}>
          <MusicNoteIcon />
          <span className="video-subtitle">Áudio do trailer</span>
          <Divider className="mr-divider" />
        </Grid>

        {audioFiles.map(
          (file, index) =>
            audioIdioma[index] && (
              <Grid container spacing={2} key={index} sx={{ padding: '15px' }}>
                <Grid item xs={4}>
                  <Form.Group
                    className="mb-3"
                    style={{ height: 'auto' }}
                    controlId="formUnit">
                    <InputLabel
                      className="form-label"
                      id="select-standard-label"
                      htmlFor="audioIdioma">
                      Idioma
                    </InputLabel>
                    <TextField
                      value={audioFiles[index]?.label}
                      fullWidth
                      disabled={audioFiles[index]?.mediaId || viewFields}
                      //
                      variant="standard"
                      style={{ marginTop: 6 }}
                      id={`trailer-audio-language-${index}`}
                    />
                  </Form.Group>
                </Grid>

                <Grid item xs={8}>
                  <div className="file-container">
                    <div style={{ maxWidth: '300px' }}>
                      <InputLabel
                        className="select-label"
                        style={{ marginBottom: 24, marginTop: 0 }}>
                        Arquivo
                        <span
                          name={'audio_' + index + '_idioma'}
                          href="/"
                          //onClick={ClickHandler}
                          disabled={viewFields}
                          id="video-subtitle-accessibility">
                          {file.accessibility === 'true' ||
                          file.accessibility === true ? (
                            <Chip
                              icon={<SurroundSoundIcon color="primary" />}
                              label="Áudio descrição"
                              sx={{ fontSize: '12px', marginLeft: '5px' }}
                              size="small"
                            />
                          ) : (
                            ''
                          )}
                        </span>
                      </InputLabel>

                      <span
                        name={'audio_' + index + '_idioma'}
                        style={{
                          fontWeight: '400',
                          color: '#0000CC',
                          borderBottom: '1px solid rgba(208, 213, 221, 1)',
                          textDecoration: 'none',
                          overflowWrap: 'break-word',
                        }}
                        disabled={viewFields}
                        id="collection-trailer-subtitle-finame">
                        {file.name}
                      </span>
                    </div>

                    <Button
                      disabled={
                        audioTrailerUploadProgress?.percent === 100 ||
                        audioTrailerUploadProgress === false
                          ? false
                          : true
                      }
                      color="error"
                      style={{
                        textTransform: 'capitalize',
                        color:
                          audioTrailerUploadProgress?.percent === 100 ||
                          audioTrailerUploadProgress === false
                            ? 'rgba(255, 98, 98, 1)'
                            : 'rgba(0, 0, 0, 0.38)',
                      }}
                      startIcon={<NotInterestedOutlinedIcon />}
                      onClick={async () => {
                        setConfirmDialogAction({
                          isOpen: true,
                          title: (
                            <div className="modalTitleText">
                              Deseja remover a mídia?
                            </div>
                          ),
                          subTitle: (
                            <div className="modalBodyText">
                              Você está deletando o arquivo permanentemente,
                              deseja prosseguir?
                            </div>
                          ),
                          children: (
                            <div className="modalRemoveItem">
                              <DeleteOutlineOutlinedIcon
                                color="error"
                                fontSize="12px"
                              />
                            </div>
                          ),
                          confirmTextButton: 'Sim',
                          color: 'error',
                          onConfirm: async () => {
                            setConfirmDialogAction({ isOpen: false });
                            let path = `/${getValues(
                              'trailerId'
                            )}/audio-tracks/${audioFiles[index].audioTrackId}`;
                            await deleteAudio(
                              audioFiles[index],
                              path,
                              setIsLoading,
                              setNotify,
                              setConfirmDialogAction
                            );

                            deleteFilesFromList(
                              audioFiles,
                              setAudioFiles,
                              index
                            );
                            deleteFilesFromList(
                              audioIdioma,
                              setAudioIdioma,
                              index
                            );
                            setValue(
                              'audio_idioma',
                              deleteFilesFromList(audioIdioma, false, index)
                            );

                            setNotify({
                              isOpen: true,
                              message: 'Áudio removido com sucesso.',
                              type: 'success',
                              title: 'Sucesso!',
                            });
                          },
                          showConfirmationButton: { showConfirmationButton },
                          closeTextButton: 'Não',
                        });
                      }}
                      id="collection-remove-subtitle-button">
                      Remover
                    </Button>
                  </div>
                </Grid>
              </Grid>
            )
        )}
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Form.Group
            className="mb-3"
            style={{ height: 'auto', marginTop: 10 }}
            controlId="formUnit">
            <Controller
              name={'audio_idioma'}
              control={control}
              render={({
                field: { onChange, value, onBlur },
                fieldState: { errors, isValid, isTouched, isDirty },
                formState,
              }) => (
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: '224px auto',
                    gap: 2,
                  }}>
                  <Box>
                    <InputLabel
                      className="form-label"
                      id="select-standard-label"
                      htmlFor="units">
                      Idioma
                    </InputLabel>
                    <AsyncPaginate
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          '&:hover': {
                            borderColor: 'transparent',
                            borderRadius: '0px',
                            border: 0,
                            borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                          },
                          borderRadius: '0px',
                          border: 0,
                          borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                          width: 'auto',
                          padding: 0,
                          margin: 0,
                        }),
                        singleValue: base => ({
                          ...base,
                          // padding: 5,
                          borderRadius: 6,
                          color: 'rgba(25, 28, 31, 1)',
                          fontSize: '15px',
                          display: 'flex',
                        }),
                        menuList: base => ({
                          ...base,
                          maxHeight: '150px',
                        }),
                      }}
                      theme={theme => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          primary25: '#e9e9ea',
                          primary: '#0A6CCF',
                          width: 'auto',
                        },
                      })}
                      menuPosition="fixed"
                      noOptionsMessage={() => 'Nada encontrado'}
                      loadingMessage={() => 'Carregando...'}
                      loadOptions={defaultLanguageWithLabels}
                      // isMulti
                      value={
                        value || { value: '', label: 'Selecione o Idioma' }
                      }
                      isDisabled={
                        (!getValues('trailerId') && !canAddAudio) || viewFields
                      }
                      // || viewStepOneFields
                      isSearchable={true}
                      placeholder="Selecione o idioma"
                      onChange={selectedOption => {
                        onChange(selectedOption);
                        setCanAddAudio(true);
                        setAudioIdioma(prevAudio => [
                          ...prevAudio,
                          selectedOption,
                        ]);
                      }}
                      id="collection-audio-traller-select"
                    />
                  </Box>
                  <Box>
                    <InputLabel
                      className="select-label"
                      style={{ marginTop: 4, marginBottom: 12 }}>
                      Arquivo
                    </InputLabel>
                    <Tooltip.Info
                      title="Atenção"
                      description="Antes de selecionar o arquivo selecione o idioma"
                      show={!canAddAudio || viewFields}>
                      <Uploader
                        register={register}
                        name={'audio_file_trailer'}
                        //mediaContentType={'VIDEO'}
                        icon={<FileUploadOutlinedIcon />}
                        accept=".mp3, .wav, .aiff, .flac"
                        fileInputRef={fileInputAudioRef}
                        file={audioFiles}
                        title={'Selecionar faixa'}
                        isDisabled={!canAddAudio || viewFields}
                        apiName={'admin'}
                        path={`/admin/media/${getValues(
                          'trailerId'
                        )}/audio-tracks`}
                        token={idToken}
                        id={getValues('id')}
                        language={getValues('audio_idioma')}
                        userId={userId}
                        userName={userName}
                        setIsLoading={setIsLoading}
                        isLoading={isLoading}
                        setProps={setAudioFiles}
                        setNotify={setNotify}
                        type={{
                          label: 'audio',
                          name: 'MAIN',
                          model: 'TRAILER',
                        }}
                        getValues={getValues}
                        setValue={setValue}
                        setAuth={setAuth}
                        isAcessibilityCheck={true}
                        nameIsAcessibilityCheck={'audio'}
                      />
                    </Tooltip.Info>
                    {audioTrailerUploadProgress?.percent > 0 &&
                      audioTrailerUploadProgress?.percent < 100 && (
                        <Stack
                          sx={{
                            width: '100%',
                            color: 'grey.500',
                            padding: '15px',
                          }}
                          spacing={2}>
                          <label>{audioTrailerUploadProgress?.name}</label>
                          <LinearProgress
                            color="secondary"
                            variant="determinate"
                            value={audioTrailerUploadProgress?.percent}
                          />
                        </Stack>
                      )}
                  </Box>
                </Box>
              )}
            />
          </Form.Group>
        </Grid>
      </Grid>
      {/* inicio video linguagem sinais */}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="video_label-title" style={{ marginTop: 40 }}>
            Vídeo de linguagem de sinais
          </div>
          <SignLanguageOutlinedIcon style={{ color: 'rgba(81, 93, 113, 1)' }} />
          <span className="video-subtitle">Vídeo linguagem de sinais</span>
          <Divider className="mr-divider" />
        </Grid>
      </Grid>
      {videoSignLanguageFile?.ACCESSIBILITY?.mediaId && (
        <Grid container spacing={2} sx={{ padding: '15px' }}>
          <Grid item xs={4}>
            <Form.Group style={{ height: 'auto' }} controlId="formUnit">
              <InputLabel
                className="form-label"
                id="select-standard-label"
                htmlFor="units">
                Idioma
              </InputLabel>
              <TextField
                value={videoSignLanguage?.label || videoSignLanguage[0]?.label}
                fullWidth
                variant="standard"
                disabled={true}
                style={{ marginTop: 6 }}
                id="accessibility-language-select-value"
              />
            </Form.Group>
          </Grid>
          <Grid item xs={8}>
            <Form.Group
              style={{ height: 'auto', paddingRight: 15 }}
              controlId="formVideoFile">
              <div className="file-container">
                <div style={{ maxWidth: 300, marginRight: 15 }}>
                  <InputLabel
                    className="select-label"
                    style={{ marginBottom: 23, marginTop: 0 }}>
                    Arquivo
                  </InputLabel>
                  <Controller
                    name={'video_signLanguage_file'}
                    control={control}
                    render={({
                      field: { onChange, value, onBlur },
                      fieldState: { error, invalid, isTouched, isDirty },
                      formState,
                    }) => (
                      <span
                        // onClick={ClickHandler}
                        // href="/"
                        style={{
                          fontWeight: '400',
                          color: '#0000CC',
                          borderBottom: '1px solid rgba(208, 213, 221, 1)',
                          textDecoration: 'none',
                          overflowWrap: 'break-word',
                        }}
                        onChange={e => {
                          onChange(e);
                        }}
                        value={value}
                        onBlur={onBlur}
                        disabled={Boolean(viewFields || viewStepTwoFields)}
                        id="accessibility-video-filename">
                        {videoSignLanguageFile?.ACCESSIBILITY?.name}
                      </span>
                    )}
                  />
                </div>
                <Button
                  disabled={Boolean(viewFields || viewStepTwoFields)}
                  color="error"
                  id="accessibility-remove-file"
                  style={{
                    textTransform: 'capitalize',
                    color: 'rgba(255, 98, 98, 1)',
                  }}
                  startIcon={<NotInterestedOutlinedIcon />}
                  onClick={async () => {
                    setConfirmDialogAction({
                      isOpen: true,
                      title: (
                        <div className="modalTitleText">
                          Deseja remover a legenda?
                        </div>
                      ),
                      subTitle: (
                        <div className="modalBodyText">
                          Você está deletando o arquivo permanentemente, deseja
                          prosseguir?
                        </div>
                      ),
                      children: (
                        <div className="modalRemoveItem">
                          <DeleteOutlineOutlinedIcon
                            color="error"
                            fontSize="12px"
                          />
                        </div>
                      ),
                      confirmTextButton: 'Sim',
                      color: 'error',
                      onConfirm: async () => {
                        await handleDeletevideoSignLanguage(
                          videoSignLanguageFile,
                          getValues('mediaWithAcessibilityId'),
                          getValues('id'),
                          getValues('version')
                        );
                      },
                      showConfirmationButton: { showConfirmationButton },
                      closeTextButton: 'Não',
                    });
                  }}>
                  Remover
                </Button>
              </div>
            </Form.Group>
          </Grid>
        </Grid>
      )}
      {/* {videoSignLanguageFile?.ACCESSIBILITY && ( */}
      <Grid container spacing={2}>
        <Grid
          item
          xs={4}
          className={
            videoSignLanguageFile?.ACCESSIBILITY?.name ? ' hidden' : ''
          }>
          <Form.Group
            style={{ height: 'auto' }}
            controlId="formUnit"
            id="accessibility-language-video-select">
            <InputLabel
              className="select-label"
              style={{ marginBottom: 8, marginTop: 0 }}>
              Idioma
            </InputLabel>
            <Controller
              name={'video_sign_trailer_language'}
              control={control}
              render={({
                field: { onChange, value, onBlur },
                fieldState: { errors, isValid, isTouched, isDirty },
                formState,
              }) => (
                <AsyncPaginate
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      '&:hover': {
                        borderColor: 'transparent',
                        borderRadius: '0px',
                        border: 0,
                        borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                      },
                      borderRadius: '0px',
                      border: 0,
                      borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                      width: 'auto',
                      padding: 0,
                      margin: 0,
                    }),
                    singleValue: base => ({
                      ...base,
                      // padding: 5,
                      borderRadius: 6,
                      color: 'rgba(25, 28, 31, 1)',
                      fontSize: '15px',
                      display: 'flex',
                    }),
                    menuList: base => ({
                      ...base,
                      maxHeight: '150px',
                    }),
                  }}
                  theme={theme => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                      ...theme.colors,
                      primary25: '#e9e9ea',
                      primary: '#0A6CCF',
                      width: 'auto',
                    },
                  })}
                  menuPosition="fixed"
                  noOptionsMessage={() => 'Nada encontrado'}
                  loadingMessage={() => 'Carregando...'}
                  loadOptions={defaultLanguageWithLabels}
                  isDisabled={Boolean(viewFields || viewStepTwoFields)}
                  value={value || { value: '', label: 'Selecione o Idioma' }}
                  id="video-select-accesibility-main-language"
                  isSearchable={true}
                  placeholder="Selecione o idioma"
                  onChange={selectedOption => {
                    onChange(selectedOption);
                    setVideoSignLanguage(prevSubtitle => [
                      ...prevSubtitle,
                      selectedOption,
                    ]);
                  }}
                />
              )}
            />
          </Form.Group>
        </Grid>
        <Grid item xs={8}>
          <Form.Group
            style={{ height: 'auto', paddingRight: 15 }}
            controlId="formVideoFile"
            id="accessibility-video-upload">
            <div className="file-container">
              <div>
                <InputLabel
                  className={
                    videoSignLanguageFile?.ACCESSIBILITY?.name
                      ? 'select-label hidden'
                      : 'select-label '
                  }
                  style={{ marginBottom: 12, marginTop: 0 }}>
                  Arquivo
                </InputLabel>
                <Tooltip.Info
                  title="Atenção"
                  description="Antes de selecionar o arquivo selecione o idioma"
                  show={
                    !videoSignLanguageFile?.ACCESSIBILITY?.mediaId &&
                    (videoSignLanguageFile?.ACCESSIBILITY?.name ||
                      !getValues('video_sign_trailer_language') ||
                      viewFields ||
                      viewStepTwoFields)
                  }>
                  <Uploader
                    register={register}
                    name={'trailer_sign_file'}
                    icon={<FileUploadOutlinedIcon />}
                    accept={
                      'video/AIV,video/MP4,video/MOV,video/WEBM,video/MXF,video/WMV,video/MPEG,video/3GP,video/ASF,video/mp4,video/x-m4v,video/*'
                    }
                    fileInputRef={fileInputVideoSignRef}
                    file={videoSignLanguageFile}
                    title={'Selecionar Vídeo'}
                    isDisabled={
                      videoSignLanguageFile?.ACCESSIBILITY?.name ||
                      !getValues('video_sign_trailer_language') ||
                      viewFields ||
                      viewStepTwoFields
                    }
                    apiName={'admin'}
                    path={`/admin/media`}
                    token={idToken}
                    id={getValues('id')}
                    language={getValues('video_sign_trailer_language')}
                    userId={userId}
                    userName={userName}
                    setIsLoading={setIsLoading}
                    isLoading={isLoading}
                    setProps={setVideoSignLanguageFile}
                    setNotify={setNotify}
                    type={{ label: 'video', name: 'ACCESSIBILITY' }}
                    getValues={getValues}
                    setValue={setValue}
                    setAuth={setAuth}
                  />
                </Tooltip.Info>
                {videoAcessibilityUploadProgress?.percent > 0 &&
                  videoAcessibilityUploadProgress?.percent < 100 && (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: '100%', mr: 1 }}>
                        <label style={{ fontSize: '12px', color: 'blue' }}>
                          {videoAcessibilityUploadProgress?.name}
                        </label>
                        <LinearProgress
                          variant="determinate"
                          value={videoAcessibilityUploadProgress?.percent}
                          sx={{ width: '100%' }}
                        />
                      </Box>
                      <Box sx={{ minWidth: 35 }}>
                        <Typography variant="body2" color="text.secondary">
                          {videoAcessibilityUploadProgress?.percent}%
                        </Typography>
                      </Box>
                    </Box>
                  )}
              </div>
            </div>
          </Form.Group>
        </Grid>
      </Grid>
      {/* )} */}

      {/* fim video linguagem sinais */}

      {/* início LEGENDAS video linguagem sinais */}
      <Grid item xs={12} style={{ marginTop: 27 }}>
        <KeyboardAltOutlinedIcon style={{ color: 'rgba(81, 93, 113, 1)' }} />
        <span className="video-subtitle">
          Legendas vídeo de linguagem de sinais
        </span>
        <Divider className="mr-divider" />
      </Grid>
      {subtitleVideoSignLanguageOptionFile.map(
        (file, index) =>
          subtitleVideoSignLanguageOptionFile[index] && (
            <Grid container spacing={2} key={index} sx={{ padding: '15px' }}>
              <Grid item xs={4}>
                <Form.Group style={{ height: 'auto' }} controlId="formUnit">
                  <InputLabel
                    className="form-label"
                    id="select-standard-label"
                    htmlFor="units">
                    Idioma
                  </InputLabel>
                  <TextField
                    value={subtitleVideoSignLanguageOptionFile[index]?.label}
                    disabled
                    fullWidth
                    variant="standard"
                    style={{ marginTop: 6 }}
                  />
                </Form.Group>
              </Grid>

              <Grid item xs={8}>
                <div className="file-container">
                  <div style={{ maxWidth: '300px' }}>
                    <InputLabel
                      className="select-label"
                      style={{ marginBottom: 24, marginTop: 0 }}>
                      Arquivo
                      <span
                        name={'legenda_' + index + '_idioma'}
                        href="/"
                        //onClick={ClickHandler}
                        disabled={viewFields}
                        id="video-subtitle-accessibility">
                        {file.accessibility === 'true' ||
                        file.accessibility === true ? (
                          <Chip
                            icon={<ClosedCaptionIcon color="primary" />}
                            label="Legenda - Closed Caption"
                            sx={{ fontSize: '12px', marginLeft: '5px' }}
                            size="small"
                          />
                        ) : (
                          ''
                        )}
                      </span>
                    </InputLabel>

                    <span
                      name={'legenda_' + file.name + '_idioma'}
                      // href="/"
                      // onClick={ClickHandler}
                      style={{
                        fontWeight: '400',
                        color: '#0000CC',
                        borderBottom: '1px solid rgba(208, 213, 221, 1)',
                        textDecoration: 'none',
                        overflowWrap: 'break-word',
                      }}
                      disabled={Boolean(viewFields || viewStepTwoFields)}
                      id="accessibility-subtitle-filename">
                      {file.name}
                    </span>
                  </div>
                  <Button
                    // disabled={Boolean(viewFields || viewStepTwoFields)}
                    disabled={
                      legendaAccessibilityUploadProgress?.percent === 100 ||
                      legendaAccessibilityUploadProgress === false
                        ? false
                        : true
                    }
                    color="error"
                    id="accessibility-remove-subtitle-file"
                    style={{
                      textTransform: 'capitalize',
                      color:
                        legendaAccessibilityUploadProgress?.percent === 100 ||
                        legendaAccessibilityUploadProgress === false
                          ? 'rgba(255, 98, 98, 1)'
                          : 'rgba(0, 0, 0, 0.38)',
                    }}
                    startIcon={<NotInterestedOutlinedIcon />}
                    onClick={() => {
                      setConfirmDialogAction({
                        isOpen: true,
                        title: (
                          <div className="modalTitleText">
                            Deseja remover a legenda?
                          </div>
                        ),
                        subTitle: (
                          <div className="modalBodyText">
                            Você está deletando o arquivo permanentemente,
                            deseja prosseguir?
                          </div>
                        ),
                        children: (
                          <div className="modalRemoveItem">
                            <DeleteOutlineOutlinedIcon
                              color="error"
                              fontSize="12px"
                            />
                          </div>
                        ),
                        confirmTextButton: 'Sim',
                        color: 'error',
                        onConfirm: async () => {
                          await await handleDeleteSignLanguageOption(
                            file,
                            subtitleVideoSignLanguageOption[index],
                            index
                          );
                        },
                        showConfirmationButton: { showConfirmationButton },
                        closeTextButton: 'Não',
                      });
                    }}>
                    Remover
                  </Button>
                </div>
              </Grid>
            </Grid>
          )
      )}
      <Grid container spacing={2} sx={{ padding: '15px' }}>
        <Grid item xs={4}>
          <Form.Group
            style={{ height: 'auto' }}
            controlId="formUnit"
            id="accessibility-subtitle-upload">
            <Controller
              name={'subtitle_sign_language'}
              control={control}
              render={({
                field: { onChange, value, onBlur },
                fieldState: { errors, isValid, isTouched, isDirty },
                formState,
              }) => (
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: '224px auto',
                    gap: 2,
                  }}>
                  <Box>
                    <InputLabel className="select-label">Idioma</InputLabel>
                    <AsyncPaginate
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          '&:hover': {
                            borderColor: 'transparent',
                            borderRadius: '0px',
                            border: 0,
                            borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                          },
                          borderRadius: '0px',
                          border: 0,
                          borderBottom: '1px solid var(--gray-300, #D0D5DD)',
                          width: 'auto',
                          padding: 0,
                          margin: 0,
                        }),
                        singleValue: base => ({
                          ...base,
                          // padding: 5,
                          borderRadius: 6,
                          color: 'rgba(25, 28, 31, 1)',
                          fontSize: '15px',
                          display: 'flex',
                        }),
                        menuList: base => ({
                          ...base,
                          maxHeight: '150px',
                        }),
                      }}
                      theme={theme => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          primary25: '#e9e9ea',
                          primary: '#0A6CCF',
                          width: 'auto',
                        },
                      })}
                      menuPosition="fixed"
                      noOptionsMessage={() => 'Nada encontrado'}
                      loadingMessage={() => 'Carregando...'}
                      loadOptions={defaultLanguageWithLabels}
                      isDisabled={Boolean(
                        !getValues('mediaWithAcessibilityId') ||
                          viewFields ||
                          viewStepTwoFields
                      )}
                      id="video-accessibility-select-subtitles-languages"
                      value={
                        value || { value: '', label: 'Selecione o Idioma' }
                      }
                      isSearchable={true}
                      placeholder="Selecione o idioma"
                      onChange={selectedOption => {
                        onChange(selectedOption);
                        setTrailerLegendSignal(selectedOption);
                      }}
                    />
                  </Box>
                  <Box>
                    <InputLabel
                      className="select-label"
                      style={{ marginBottom: 5 }}>
                      Arquivo
                    </InputLabel>
                    <Tooltip.Info
                      title="Atenção"
                      description="Antes de selecionar o arquivo selecione o idioma"
                      show={
                        !getValues('subtitle_sign_language') ||
                        viewFields ||
                        viewStepTwoFields ||
                        !videoSignLanguageFile?.ACCESSIBILITY?.mediaId
                      }>
                      <Uploader
                        register={register}
                        name={'subtitle_trailer_sign_language_file'}
                        icon={<FileUploadOutlinedIcon />}
                        accept={'.srt,.txt,.vvt'}
                        fileInputRef={
                          fileInputSubtitleVideoSignLanguageOptionRef
                        }
                        file={subtitleVideoSignLanguageOptionFile}
                        title={'Selecionar legenda'}
                        isDisabled={
                          !getValues('subtitle_sign_language') ||
                          viewFields ||
                          viewStepTwoFields ||
                          !videoSignLanguageFile?.ACCESSIBILITY?.mediaId
                        }
                        apiName={'admin'}
                        path={`/admin/media/${getValues(
                          'mediaWithAcessibilityId'
                        )}/subtitles`}
                        token={idToken}
                        id={getValues('id')}
                        language={trailerLegendSignal}
                        languages={languages}
                        userId={userId}
                        userName={userName}
                        setIsLoading={setIsLoading}
                        isLoading={isLoading}
                        setProps={setSubtitleVideoSignLanguageOptionFile}
                        setNotify={setNotify}
                        type={{ label: 'legenda', name: 'ACCESSIBILITY' }}
                        getValues={getValues}
                        setValue={setValue}
                        setAuth={setAuth}
                        isAcessibilityCheck={true}
                        nameIsAcessibilityCheck={'signals'}
                      />
                    </Tooltip.Info>
                    {legendaAccessibilityUploadProgress?.percent > 0 &&
                      legendaAccessibilityUploadProgress?.percent < 100 && (
                        <Stack
                          sx={{
                            width: '100%',
                            color: 'grey.500',
                            padding: '15px',
                          }}
                          spacing={2}>
                          <label>
                            {legendaAccessibilityUploadProgress?.name}
                          </label>
                          <LinearProgress
                            color="secondary"
                            variant="determinate"
                            value={legendaAccessibilityUploadProgress?.percent}
                          />
                        </Stack>
                      )}
                  </Box>
                </Box>
              )}
            />
          </Form.Group>
        </Grid>
      </Grid>
      <Modal
        confirmDialogAction={confirmDialogAction}
        setConfirmDialogAction={setConfirmDialogAction}
      />
    </div>
  );
}

export default StepTwo;
